import React from 'react';
import { useTranslation } from 'react-i18next';
import { Prompt } from '../Prompt.component';

interface LeavePromptProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const LeavePrompt: React.FC<LeavePromptProps> = ({ isOpen, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Prompt
      type="confirmation"
      isBold={true}
      size={'xs'}
      open={isOpen}
      mainText={"Czy na pewno chcesz opuścić stronę?"}
      subTexts={[{ text: "Wprowadzone zmiany nie zostaną zapisane"}]}
      mainActionButtonText="Tak"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
